<template>
  <div class="rounded-sm p-4">
    <div class="flex">
      <div class="ml-3">
        <h3
          class="text-sm leading-5 font-bold text-lg"
          v-text="'Attention Needed'"
        />
        <div class="mt-2 text-sm leading-5">
          <p
            v-if="onlyRequiresBankAccount"
            v-text="`You have 1 outstanding requirement. Please scroll down to the Payments section to provide bank account details for where you'd like to receive your payments.`"
          />
          <p
            v-else
            v-text="`You have ${totalNumberOfRequirements} outstanding ${requirementsText}. Click the button below to review and submit your information.`"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script type="text/babel">
export default {
  name: 'NonDeadlineRequirements',
  props: {
    currentlyDue: {
      type: Array,
      required: true,
    },
    eventuallyDue: {
      type: Array,
      required: true,
    },
    pastDue: {
      type: Array,
      required: true,
    },
  },
  computed: {
    totalNumberOfRequirements() {
      const combinedRequirements = [
        ...this.currentlyDue,
        ...this.eventuallyDue,
        ...this.pastDue,
      ]

      return new Set(combinedRequirements).size
    },
    requirementsText() {
      return this.totalNumberOfRequirements > 1 ? 'requirements' : 'requirement'
    },
    onlyRequiresBankAccount() {
      const combinedRequirements = new Set([
        ...this.currentlyDue,
        ...this.eventuallyDue,
        ...this.pastDue,
      ])

      return combinedRequirements.size === 1 && combinedRequirements.has('external_account')
    },
  },
}
</script>
